import React, { useCallback } from 'react';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import Button from 'components/inputs/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { UNLOCK_CONNECTOR } from 'actions/chargerOcpp';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import Select from 'components/inputs/Select';
import * as Yup from 'yup';

const UnlockConnectorSchema = Yup.object().shape({
  connectorId: Yup.number().required('Connector Id is required'),
});

const UnlockConnectorForm = () => {
  const { chargerId } = useParams();
  const dispatch = useDispatch();
  const chargerDetailData = useSelector((state) => state.charger.chargerDetails);

  const initialValues = {
    connectorId: '',
  };

  const handleUnlockConnector = useCallback((data, resetForm) => {
    dispatch({
      type: UNLOCK_CONNECTOR,
      payload: { data },
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            toast.success('Connector unlocked successfully');
            resetForm();
          }
        }
      },
    });
  }, []);

  return (
    <React.Fragment>
      <div className="serverOperation-title-name">UNLOCK CONNECTOR</div>
      <div className="serverOperation-content-wrapper">
        <Card className="serverOperation-form-main">
          <div className="serverOperation-form__block">
            <Formik
              initialValues={initialValues}
              validationSchema={UnlockConnectorSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                const formData = {
                  id: chargerId,
                  ...values,
                };
                handleUnlockConnector(formData, resetForm);
                setSubmitting(false);
              }}
            >
              {({ values, errors, touched, handleSubmit, setFieldValue, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="serverOperation-form__inner">
                    <Row>
                      <Col>
                        <Select
                          isRequired
                          label="Connector Name"
                          placeholder="Select Connector Name"
                          options={_.map(_.get(chargerDetailData, 'plugs', []), (item) => {
                            return { label: `${item.name} - ${item.connector_id}`, value: item.connector_id };
                          })}
                          name="connectorId"
                          value={values.connectorId}
                          onChange={(val) => setFieldValue(`connectorId`, val)}
                          error={errors.connectorId && touched.connectorId ? errors.connectorId : null}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="serverOperation-save--btn--block">
                    <Button type="submit" className="serverOperation-save-btn save--btn" disabled={isSubmitting}>
                      Unlock Connector
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
export default UnlockConnectorForm;
